<template>
  <div v-if="currentTab" class="banking-tab relative-position">
    <div class="col-12">
      <q-btn-group rounded unelevated>
        <q-btn
          v-for="(item, index) in allCountries"
          :key="item.code"
          :name="item.value"
          class="no-scope-css capitalize-btn"
          :label="item.label"
          rounded
          unelevated
          :disable="lockData"
          :color="item.value === currentTab ? 'action-button-success' : 'grey-5'"
          @click="setCountrie(item.value)"
        ></q-btn>
      </q-btn-group>
    </div>
    <q-tab-panels v-model="currentTab">
      <q-tab-panel v-for="(item, index) in allCountries" :key="item.code" :name="item.value">
        <div class="pd-10">
          <div v-if="isShowAddBank" class="empty relative-position">
            <div class="row justify-center">
              <div class="col-md-auto">
                <q-btn icon="add" color="positive" label="Setup Bank" @click="addBank()" />
              </div>
            </div>
          </div>
          <div v-for="(bank, bankIndex) in memberData.banking_country" :key="bank.id">
            <div v-if="bank.country_id === currentTab">
              <div class="content">
                <div class="row q-col-gutter-sm items-center">
                  <div v-if="!lockData" class="col-12 q-mb-md">
                    <info
                      text-color="text-negative"
                      icon-name="info"
                      message="Remove bank data if not required to proceed save"
                    >
                      <template slot="bottom-actions">
                        <q-btn color="negative" rounded unelevated @click="clearData(bankIndex)">
                          {{ $t('Common.Remove.Text') }}
                        </q-btn>
                      </template>
                    </info>
                  </div>
                  <div class="col-12">
                    <q-btn-group rounded unelevated>
                      <q-btn
                        v-for="(banking, index) in bank.payment_data.bank_data"
                        :key="`banking-${index}`"
                        class="no-scope-css"
                        :label="banking.title"
                        rounded
                        unelevated
                        :disable="lockData"
                        :color="bank.payment_data.selected === banking.id ? 'action-button-success' : 'grey-5'"
                        @click="setBankingType(banking.id, bankIndex)"
                      ></q-btn>
                    </q-btn-group>
                  </div>

                  <div
                    v-for="(banking, index1) in bank.payment_data.bank_data"
                    class="fields"
                    :class="bank.payment_data.selected === banking.id ? 'col-md-6' : 'col-12'"
                  >
                    <q-card v-if="bank.payment_data.selected === banking.id" square class="fit no-box-shadow">
                      <div class="row q-col-gutter-sm">
                        <div v-if="banking.fields.length > 0" class="col-12">
                          <div class="row q-col-gutter-md">
                            <div
                              v-for="(field, index2) in sortDynamicFields(banking.fields)"
                              :key="field.label"
                              class="dynamic-field"
                              :class="{
                                'col-6': field.share && field.share.pos,
                                'col-12': !field.share,
                              }"
                            >
                              <q-input
                                v-if="field.type === 'input'"
                                v-model.trim="
                                  field.autofill !== undefined &&
                                  bank.payment_data.bank_data[index1].fields[
                                    setDynamicFieldIndex(bank.payment_data.bank_data[index1].fields, field.index)
                                  ].value === '' &&
                                  !isFieldInEditState(field.index)
                                    ? getAutoFill(field.autofill, index1, field.index)
                                    : bank.payment_data.bank_data[index1].fields[
                                        setDynamicFieldIndex(bank.payment_data.bank_data[index1].fields, field.index)
                                      ].value
                                "
                                hide-bottom-space
                                dense
                                outlined
                                :label="
                                  typeof field.share !== 'undefined' && field.share.pos === 'C' ? '' : field.label
                                "
                                :error="
                                  field.required
                                    ? validation.banking_country.$each[bankIndex].payment_data.bank_data.$each[index1]
                                        .fields.$each[
                                        setDynamicFieldIndex(bank.payment_data.bank_data[index1].fields, field.index)
                                      ].value.$error
                                    : false
                                "
                                class="text-capitalize"
                                :class="{ required: field.required || false }"
                                clearable
                                :type="field.input_type ? field.input_type : 'text'"
                                :readonly="
                                  lockData ||
                                    (field.readonly
                                      ? field.readonly
                                      : field.autofill !== undefined && !isFieldInEditState(field.index))
                                "
                                @input="
                                  field.readonly
                                    ? setInheritFieldValue(index1, field.inherit_index, field.inherit_column)
                                    : '',
                                    validation.banking_country.$each[bankIndex].payment_data.bank_data.$each[index1]
                                      .fields.$each[
                                      setDynamicFieldIndex(bank.payment_data.bank_data[index1].fields, field.index)
                                    ].value.$touch
                                "
                              />
                              <q-select
                                v-if="
                                  field.type === 'select' ||
                                    (field.type === 'custom-select' && field.type !== 'masters-select')
                                "
                                v-model="
                                  bank.payment_data.bank_data[index1].fields[
                                    setDynamicFieldIndex(bank.payment_data.bank_data[index1].fields, field.index)
                                  ].value
                                "
                                :readonly="
                                  lockData ||
                                    ((field.key === 'countries' ||
                                      setDynamicFieldKeyOptionsData(field.key, field.identifier, index1, index2)
                                        .length < 1) &&
                                      field.type !== 'custom-select')
                                "
                                :label="field.label || false"
                                :options="
                                  field.options
                                    ? field.options
                                    : setDynamicFieldKeyOptionsData(field.key, field.identifier, index1, index2)
                                "
                                :class="{ required: field.required || false }"
                                :error="
                                  field.required
                                    ? validation.banking_country.$each[bankIndex].payment_data.bank_data.$each[index1]
                                        .fields.$each[
                                        setDynamicFieldIndex(bank.payment_data.bank_data[index1].fields, field.index)
                                      ].value.$error
                                    : false
                                "
                                @input="
                                  field.trigger ? triggerInherit(index1, field.trigger, field.key, field.value) : '',
                                    field.required
                                      ? validation.banking_country.$each[bankIndex].payment_data.bank_data.$each[index1]
                                          .fields.$each[
                                          setDynamicFieldIndex(bank.payment_data.bank_data[index1].fields, field.index)
                                        ].value.$touch
                                      : false
                                "
                              ></q-select>
                              <q-select
                                v-if="field.type === 'masters-select'"
                                v-model="
                                  bank.payment_data.bank_data[index1].fields[
                                    setDynamicFieldIndex(bank.payment_data.bank_data[index1].fields, field.index)
                                  ].value
                                "
                                :error="
                                  field.required
                                    ? validation.banking_country.$each[bankIndex].payment_data.bank_data.$each[index1]
                                        .fields.$each[
                                        setDynamicFieldIndex(bank.payment_data.bank_data[index1].fields, field.index)
                                      ].value.$error
                                    : false
                                "
                                :class="{ required: field.required || false }"
                                :label="field.label || false"
                                :readonly="lockData"
                                :options="field.options ? field.options : masterDataOptionsCreator(field.identifier)"
                                @input="
                                  field.trigger ? triggerInherit(index1, field.trigger) : '',
                                    validation.banking_country.$each[bankIndex].payment_data.bank_data.$each[index1]
                                      .fields.$each[
                                      setDynamicFieldIndex(bank.payment_data.bank_data[index1].fields, field.index)
                                    ].$touch
                                "
                              ></q-select>
                              <q-btn
                                v-if="!isNewUser && !lockData && field.autofill !== undefined && !field.readonly"
                                class="q-mt-xs"
                                color="primary"
                                rounded
                                unelevated
                                outline
                                :label="isFieldInEditState(field.index) ? 'Done' : 'Edit'"
                                @click="setEditAutoFill(field.index)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </q-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </div>
</template>
<script>
import { MasterDataTransformarMixin, ScopeConfigMixin } from 'src/application/global/mixins'
import trans from 'src/application/global/components/common/transition/transition'
import EmptyList from '../empty/emptyList'
import QSelect from '../quasar/q-select/QSelectCustom'
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import { MemberAddressesTab } from './index'

export default {
  name: 'MemberAllCountryBankInfoTab',
  components: {
    MemberAddressesTab,
    trans,
    EmptyList,
    QSelect,
  },
  mixins: [MasterDataTransformarMixin, ScopeConfigMixin],
  props: {
    memberData: {
      type: Object,
      required: true,
    },
    lockData: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      required: true,
    },
    isNewUser: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedAddress: '',
    selectedCountry: '',
    selectedCountryByIndex: [],
    editAutoFill: [],
    cachedIncomeTaxCountryID: null,
    currentTab: null,
  }),
  watch: {
    memberData: {
      handler(to) {
        let self = this
        if (!self.currentTab) {
          let currentTabInfo = self.allCountries.find(x => x.value === to.details.country_id)
          this.setCountrie(currentTabInfo.value)
          // self.currentTab = currentTabInfo.value
        }
        //start
        if (to.banking_country.length > 0) {
          to.banking_country.map(item => {
            item.payment_data =
              typeof item.payment_data === 'string' ? JSON.parse(item.payment_data) : item.payment_data
            item.payment_data.checkSelectedId = `${item.country_id}${item.payment_data.selected}`
            item.payment_data.bank_data.map(bank => {
              bank.fields.map(field => {
                field.checkId = `${item.country_id}${field.parent_id}`
                if (field.label === 'Account Type') {
                  const list = this.masterDataOptionsCreator(field.identifier)
                  if (field.value === '') {
                    field.value = list.length > 0 ? list[0].value : field.value
                    field.formatted_value = list.length > 0 ? list[0].label : field.formatted_value
                  }
                  this.$forceUpdate()
                }
              })
            })
          })
          self.getBanks(self.currentTab)
          let selectedCountryIdIndex = this.memberData.banking_country.findIndex(x => x.country_id === self.currentTab)
          this.$emit('bankInfoSelectedCountryIndex', selectedCountryIdIndex)
        }
      },
      deep: true,
      immediate: true,
    },
    currentTab: {
      handler(newValue, old) {
        if (newValue) {
          let selectedCountryIdIndex = this.memberData.banking_country.findIndex(x => x.country_id === newValue)
          this.$emit('bankInfoSelectedCountryIndex', selectedCountryIdIndex)
          this.getBanks(this.currentTab)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      countriesOptions: state => state.globalCMP.countriesOptions.data,
      masterOptions: state => state.globalCMP.masterData.data.list,
      dynamicContentData: state => state.globalCMP.dynamicContentData.data,
      statesOptions: state => state.globalCMP.statesOptions.data,
      citiesOptions: state => state.globalCMP.citiesOptions.data,
      banksOptions: state => state.globalCMP.banksOptions.data,
    }),
    isEmptyBankData() {
      return (
        this.memberData.banking.payment_data.length < 1 || this.memberData.banking.payment_data.bank_data.length < 1
      )
    },
    getBankCountry() {
      let selectedCountryIdIndex = this.memberData.banking_country.findIndex(x => x.country_id === this.currentTab)
      if (selectedCountryIdIndex > -1) {
        let selectedBankId = this.memberData.banking_country[selectedCountryIdIndex].payment_data.selected
        let selectedTypeIdIndex = this.memberData.banking_country[
          selectedCountryIdIndex
        ].payment_data.bank_data.findIndex(x => x.id === selectedBankId)

        if (selectedTypeIdIndex) {
          let bankData = this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data.find(
            x => x.id === selectedTypeIdIndex
          )
          if (bankData) {
            let bankCountry = bankData.fields.find(x => x.label === 'Bank Country')
            if (bankCountry) {
              let bankCounty = this.countriesOptions.options.find(
                x => x.name.toLowerCase() === bankCountry.value.toLowerCase()
              )
              if (bankCounty) {
                return bankCounty.value
              }
            }
          }
        }
      }

      return false
    },
    getCountryID() {
      if (this.scopeEnableFeature('isIncomeTaxCountryFieldEnableBinding', 'general.feature')) {
        return this.$helpers.getValue(this.memberData, 'details.income_tax_country_id')
      } else {
        return this.$helpers.getValue(this.memberData, 'details.country_id')
      }
    },
    allCountries() {
      return this.countriesOptions.options.filter(item => item.code !== 'ARE')
    },
    isShowAddBank() {
      let currentTab = this.currentTab
      return !this.memberData.banking_country.some(obj => obj.country_id === currentTab)
    },
  },
  mounted() {
    this.master.keys = ['bank_account_type']
  },
  methods: {
    ...mapActions([
      'getLanguagesAction',
      'getDynamicContentAction',
      'getStateAction',
      'getCitiesAction',
      'getCountriesBankAction',
    ]),
    setCountrie(value) {
      let list = this.masterDataOptionsCreator('bank_account_type')
      if (list.length > 0) {
        if (this.memberData.banking_country.length > 0) {
          this.memberData.banking_country.map(item => {
            if (item.country_id === value) {
              item.payment_data =
                typeof item.payment_data === 'string' ? JSON.parse(item.payment_data) : item.payment_data
              item.payment_data.bank_data.map(bank => {
                bank.fields.map(field => {
                  if (field.label === 'Account Type') {
                    if (field.value === '') {
                      field.value = list.length > 0 ? list[0].value : field.value
                      field.formatted_value = list.length > 0 ? list[0].label : field.formatted_value
                    }
                    this.$forceUpdate()
                  }
                })
              })
            }
          })
        }
      }

      this.currentTab = value
    },
    addBank() {
      this.setPayoutTypesFields()
    },
    getBanks(countryId = false) {
      // countryId = countryId || this.getBankCountry
      // if (this.scopeEnableFeature('isIncomeTaxCountryFieldEnableBinding', 'general.feature')) {
      //   if (this.$helpers.isSet(this.memberData, 'details.income_tax_country_id', ['notEmpty', 'notNull'])) {
      //     countryId = this.$helpers.getValue(this.memberData, 'details.income_tax_country_id')
      //   }
      // }
      if (countryId) {
        let query = {
          country_id: countryId,
          relations: ['banks'],
        }
        this.getCountriesBankAction(query)
      }
    },
    setBankingType(id, index) {
      this.memberData.banking_country[index].payment_data.selected = id
    },
    setBankingType2(id) {
      this.memberData.banking.payment_data.selected = id
    },
    sortDynamicFields(fields) {
      return _.orderBy(fields, 'order', 'asc')
    },
    // Return back current index after sorting based on order to make sure inline with original array
    setDynamicFieldIndex(fields, index) {
      return fields.findIndex(x => x.index === index)
    },
    setDynamicFieldKeyOptionsData(key, identifier, index1, index2) {
      let name = key + 'Options'
      if (typeof this[name] !== 'undefined') {
        return this[name].options
      } else {
        return []
      }
    },
    setInheritFieldValue(index, triggerIndex, key, value) {
      let selectedCountryIdIndex = this.memberData.banking_country.findIndex(x => x.country_id === this.currentTab)
      let selectedBankId = this.memberData.banking_country[selectedCountryIdIndex].payment_data.selected
      let selectedTypeIdIndex = this.memberData.banking_country[
        selectedCountryIdIndex
      ].payment_data.bank_data.findIndex(x => x.id === selectedBankId)
      let data = []
      let field = this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[index].fields.find(
        x => x.index === triggerIndex
      )
      if (Object.keys(field).length > 0) {
        data = this.setDynamicFieldKeyOptionsData(key).filter(x => x.value === value)
      }
      if (data.length > 0) {
        let triggeredFieldIndex = this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[
          index
        ].fields.findIndex(x => x.index === triggerIndex)
        if (triggeredFieldIndex !== -1) {
          this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[index].fields[
            triggeredFieldIndex
          ].value = data[0][field.inherit_column]
        }
      }
      return ''
    },
    triggerInherit(index, triggerIndex, key, value) {
      this.setInheritFieldValue(index, triggerIndex, key, value)
    },
    setPayoutTypesFields() {
      if (this.currentTab) {
        let query = {
          country_id: this.currentTab,
          types: ['member_payout_options'],
        }
        this.getDynamicContentAction(query).then(res => {
          if (typeof res !== 'undefined' && res.member_payout_options.length > 0) {
            let member_payout_options = JSON.parse(res.member_payout_options)
            member_payout_options.checkSelectedId = `${this.currentTab}${member_payout_options.selected}`
            member_payout_options.bank_data.map(bank => {
              bank.fields.map(field => {
                field.checkId = `${this.currentTab}${field.parent_id}`
                if (field.label === 'Account Type') {
                  this.masterDataOptionsCreator(field.identifier)
                }
              })
            })
            let one = {
              country_id: this.currentTab,
              payment_data: member_payout_options,
              user_id: String(this.memberData.details.user_id),
            }
            this.memberData.banking_country.push(one)
          }
        })
      }
    },
    getAutoFill(key, index, fieldIndex, valueOnly = false) {
      let selectedCountryIdIndex = this.memberData.banking_country.findIndex(x => x.country_id === this.currentTab)
      let selectedBankId = this.memberData.banking_country[selectedCountryIdIndex].payment_data.selected
      let selectedTypeIdIndex = this.memberData.banking_country[
        selectedCountryIdIndex
      ].payment_data.bank_data.findIndex(x => x.id === selectedBankId)
      if (this.currentTab === this.memberData.details.country_id) {
        const value = key.split('.').reduce((a, b) => a[b], this.memberData)
        if (valueOnly) {
          return value
        }
        if (value !== '' || value !== null) {
          this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[index].fields[
            this.setDynamicFieldIndex(
              this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[index].fields,
              fieldIndex
            )
          ].value = value
        }
      } else {
        const result = this.allCountries.find(item => item.value === this.currentTab)
        if (key === 'details.country.name') {
          this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[index].fields[0].value =
            result.label
        }
        if (key === 'details.country.code_iso_2') {
          let fieldIndex = this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[
            index
          ].fields.findIndex(x => x.autofill === key)
          this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[index].fields[
            fieldIndex
          ].value = result.code_iso_2
        }
        // const otherValue = key.split('.').reduce((a, b) => a[b], this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[index].fields)

        //
        // if (otherValue !== '' || otherValue !== null) {
        //   this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[index].fields[
        //       this.setDynamicFieldIndex(this.memberData.banking_country[selectedCountryIdIndex].payment_data.bank_data[index].fields, fieldIndex)
        //       ].value = otherValue
        // }
      }
    },
    setEditAutoFill(index) {
      let editIndex = this.editAutoFill.findIndex(x => x === index)
      if (editIndex !== -1) {
        this.editAutoFill.splice(editIndex, 1)
      } else {
        this.editAutoFill.push(index)
      }
    },
    isFieldInEditState(index) {
      let editIndex = this.editAutoFill.findIndex(x => x === index)
      return editIndex !== -1
    },
    clearData(index) {
      let empty = {
        payment_data: {
          selected: '',
          bank_data: [],
        },
      }
      this.memberData.banking_country.splice(index, 1)
    },
  },
}
</script>
<style>
.q-btn {
  text-transform: none;
}
</style>
